<template>
  <div v-if="isLoaded"
       class="page-index">
    <touch-map :treasure_nums="userinfo.treasure_nums" @chest="treasure" />
    <div class="mod-icos">
      <music-player class="ico-audio"
                    :src="require('@/assets/sounds/bgm.mp3')" />
      <div class="ico-rule"
           @click="tapRule">
      </div>
      <div class="ico-look-map"
           @click="tapLookMap">
      </div>
      <div class="ico-tips"
           @click="tapTips">
      </div>
      <div class="ico-share"
           @click="tapShare">
      </div>
    </div>
    <chest-progress :count="userinfo.treasure_count"
                    class="box-progress"
                    @receive="touchChest" />
  </div>
</template>

<script>
import { instantiate, single } from '@/utils'
import ViewLoading from '@/views/loading'
import TouchMap from '@/components/touch-map'
import DialogLogin from '@/components/dialog/login'
import DialogRule from '@/components/dialog/rule'
import DialogAward from '@/components/dialog/award'
import DialogSecret from '@/components/dialog/secret'
import DialogGuide from '@/components/dialog/guide'
import DialogEgg from '@/components/dialog/egg'
import DialogShare from '@/components/dialog/share'
import ChestProgress from '@/components/progress'
import MusicPlayer from '@/components/MusicPlayer'
import DialogPrize from '@/components/dialog/prize'
import DialogFlower from '@/components/dialog/flower'
import DialogMap from '@/components/dialog/map'
import GuideMask from '@/components/GuideMask'
import { apiTreasureHuntAct, apiTreasureHuntLottery, apiTreasureHuntTreasure, apiTreasureHuntUser } from '@/api/treasure-hunt'
import { toParams } from '@/utils/to-params'
import { SHARE_APP_INFO } from '@/constants'
const local_key = 'inrice_2021_palc_treasure_chest'
export default {
  components: {
    TouchMap,
    ChestProgress,
    MusicPlayer
  },
  data() {
    return {
      isLoaded: false,
      userinfo: {
        treasure_count: 0,
        treasure_nums: {}
      },
      chest_num: [10, 15, 20]
    }
  },
  async created() {
    const { urlfrom } = toParams()
    if (['from_qrcode', 'from_mp', 'from_user'].find(item => item === urlfrom)) {
      this.$stat({
        event: urlfrom
      })
    }
    try {
      await apiTreasureHuntAct()
      this.showLoading()
    } catch (error) {
      // 活动结束
      if (error.status === 402) {
        this.showLoading()
      }
    }
  },
  async mounted() {
  },
  methods: {
    showLoading() {
      this.$setShare(SHARE_APP_INFO)
      const parmas = toParams()
      instantiate(ViewLoading, {
        isShowIndex: parmas.act !== 'inputsecret',
        onOk: async () => {
          this.isLoaded = true
          this.init()
        }
      })
    },
    async init() {
      const parmas = toParams()
      this.$stat({
        event: 'view_home'
      })
      await this.getUserInfo()
      if (parmas.act === 'inputsecret') {
        const treasure = +window.localStorage.getItem(local_key)
        if (treasure) {
          this.tapChest(treasure)
        }
      }
    },
    async getUserInfo() {
      try {
        const { data } = await apiTreasureHuntUser()
        this.userinfo = data
        if (!data.phone) {
          this.showLogin()
        }
      } catch (error) {
        this.$toast(error.message)
      }
    },
    /**
     * 没有登录手机号弹出登录框
     */
    showLogin() {
      instantiate(DialogLogin, {
        onOk: () => {
          // 引导页
          instantiate(DialogGuide, {
            onOk: () => {
              // 手指引导
              const guide = instantiate(GuideMask, {
                onTap: () => {
                  guide.close()
                  this.$event.emit('Open', 1)
                  this.treasure(1)
                }
              })
            }
          })
        }
      })
    },
    /**
     * 找到宝物
     */
    async treasure(num) {
      if (this.userinfo.treasure_nums[num]) return
      try {
        await apiTreasureHuntTreasure({
          num
        })
        this.$toast('恭喜您找到一个宝物')
        await this.getUserInfo()
        this.showAward(this.userinfo.treasure_count)
      } catch (error) {
        if (error.status === 400) {
          console.debug('已找到')
        } else if (error.status === 429) {
          this.$toast('你找得太快了，小安正在加速记录')
        } else {
          this.$toast(error.message)
        }
      }
    },
    /**
     * 显示奖品
     */
    showAward(num) {
      switch (num) {
        case 9:
          instantiate(DialogEgg)
          break
        case 10:
          this.tapChest(1)
          break
        case 15:
          this.tapChest(2)
          break
        case 20:
          {
            const dialog = instantiate(DialogFlower)
            setTimeout(() => {
              dialog.close()
              this.tapChest(3)
            }, 2000)
          }
          break
        default:
      }
    },
    tapChest(treasure) {
      if (this.userinfo.is_signal) {
        this.lottery(treasure)
        return
      }
      // 缓存点击的宝箱号
      window.localStorage.setItem(local_key, treasure)
      const dialog = instantiate(DialogSecret, {
        onOk: async (signal) => {
          const is = await this.lottery(treasure, signal)
          window.localStorage.removeItem(local_key)
          if (is) {
            this.userinfo.is_signal = 1
            dialog.close()
          }
        }
      })
    },
    // 点击宝箱
    touchChest(treasure) {
      this.$stat({
        event: ['', 'click_chest_redenvlop', 'click_chest_blue', 'click_chest_gold'][treasure]
      })
      this.tapChest(treasure)
    },
    /**
     * 抽奖
     */
    lottery: single(async function (next, treasure, signal) {
      this.$toast.clear()
      this.$loading()
      try {
        const { data: { price } } = await apiTreasureHuntLottery({
          signal,
          treasure
        })
        this.$toast.clear()
        const index = this.chest_num.findIndex(item => (this.userinfo.treasure_count) < item)
        const num = index === -1 ? 0 : this.chest_num[index] - this.userinfo.treasure_count
        instantiate(DialogPrize, {
          mete: price,
          num: num
        })
        next()
        return true
      } catch (error) {
        this.$toast.clear()
        this.$toast(error.message)
        next()
        return false
      }
    }),
    // 规则
    tapRule() {
      instantiate(DialogRule)
    },
    tapLookMap() {
      instantiate(DialogMap)
    },
    // 锦囊
    tapTips() {
      this.$event.emit('hide')
      instantiate(DialogAward)
    },
    // 分享
    tapShare() {
      this.$stat({
        event: 'click_home_share'
      })
      instantiate(DialogShare, {
        num: this.userinfo.treasure_count
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-index {
  position: relative;
  width: 100vw;
  height: 100vh;
  .mod-icos {
    margin-top: -80px;
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    .ico-audio {
      width: 100px;
      height: 100px;
      background-image: url("~@/assets/ico/ico-music-pause.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      &.playing {
        background-image: url("~@/assets/ico/ico-music.png");
      }
    }
    .ico-rule {
      margin-top: 14px;
      width: 100px;
      height: 100px;
      background-image: url("~@/assets/ico/ico-rule.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .ico-look-map {
      margin-top: 14px;
      width: 100px;
      height: 100px;
      background-image: url("../../assets/ico/ico-look-map.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .ico-tips {
      margin-top: 14px;
      width: 100px;
      height: 100px;
      background-image: url("~@/assets/ico/ico-tips.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .ico-share {
      margin-top: 14px;
      width: 100px;
      height: 100px;
      background-image: url("~@/assets/ico/ico-share.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
  .box-progress {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>